import { useMsal } from '@azure/msal-react';
import { BDPageSpinner } from '@brightdrop/bd-ui';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

type Props = {
  callback?: () => void;
};

const Logout = ({ callback }: Props): JSX.Element => {
  const { instance, inProgress } = useMsal();
  const { search } = useLocation();

  useEffect(() => {
    if (inProgress !== 'none') {
      return;
    }

    instance
      // we need to call handleRedirectPromise to complete any existing calls in MSAL
      .handleRedirectPromise()
      .then(() => {
        const path =
          instance.getConfiguration().auth.postLogoutRedirectUri ?? '';
        const url = new URL(path);

        // path could be to sso so the url will be <url>?authType=sso
        // we want to retain that so we loop over existing params and add to url
        for (const [key, value] of new URLSearchParams(search).entries()) {
          url.searchParams.set(key, value);
        }

        instance.logoutRedirect({ postLogoutRedirectUri: url.toString() });
      })
      .catch((e) => console.error(`CS Web: Logout Error -- ${e}`))
      .finally(() => {
        if (callback) {
          callback();
        }
      });
  }, [inProgress, instance, search, callback]);

  return (
    <>
      <BDPageSpinner />
    </>
  );
};

export default Logout;
